import React from "react";
import { useNavigate } from "react-router-dom";

const BrandsHeader = () => {
    const navigate = useNavigate();

    const handleClick = () => {
      navigate("/");
    };
  return (
    <div className="brand-header">
      <button className="back-button" onClick={handleClick}>← Back to Dashboard</button>
      <h1>All Brands</h1>
      <p>Complete list of brands and their enrichment status</p>
    </div>
  );
};

export default BrandsHeader;